module.exports = __webpack_public_path__ + "static/media/dropoff_active.8e8afb0d.svg";